import { useQuery } from '@tanstack/react-query'
import { desilApi } from '../lib/client'
import { ApiResponse, DesilListResult } from '../../../shared-lib/types'

export function useDesilByYear(tahun: number, enabled: boolean = true) {
    return useQuery<ApiResponse<DesilListResult>>({
        queryKey: ['desil', 'year', tahun],
        queryFn: async () => {
            try {
                const params: any = { 
                    tahun, 
                    page: 1, 
                    limit: 100 
                }
                return await desilApi.getDesil(params)
            } catch (error) {
                throw error
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
        enabled: enabled && !!tahun
    })
}